import { AvvirRoutingEvent } from "type_aliases";

export interface ManageUsersBackContext {
  label: string;
  backRouteType: string;
  backRoutePayload: Record<string, any>;
}

export type ToOrganizationManageUsersEvent = AvvirRoutingEvent<typeof TO_ORGANIZATION_MANAGE_USERS, {
  organizationId: string;
  backContext?: ManageUsersBackContext;
}>

const toOrganizationManageUsers = (organizationId: string, backContext?: ManageUsersBackContext): ToOrganizationManageUsersEvent => ({
  type: TO_ORGANIZATION_MANAGE_USERS,
  payload: { organizationId, backContext }
});

export const TO_ORGANIZATION_MANAGE_USERS = "to_organization_manage_users";

export default toOrganizationManageUsers;
